import React from 'react';
import { Search } from 'lucide-react';
import { Customer } from '../../../types';
import { DEAL_STAGES } from '../utils/dealStages';

interface DealFiltersProps {
  customers: Customer[];
  selectedCustomer: number | '';
  setSelectedCustomer: (val: number | '') => void;
  stage: string;
  setStage: (val: string) => void;
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  onRefresh: () => void;
}

const DealFilters: React.FC<DealFiltersProps> = ({
  customers,
  selectedCustomer,
  setSelectedCustomer,
  stage,
  setStage,
  searchQuery,
  setSearchQuery,
  onRefresh,
}) => {
  return (
    <>
      {/* Filters */}
      <div className="flex flex-wrap gap-3 items-end mb-4">
        <div>
          <label className="block text-sm font-medium mb-1 theme-text-primary">ClientTRAC</label>
          <select
            className="border border-white  theme-border rounded-lg p-2  focus:outline-none focus:border-blue-500 focus:ring-0  theme-bg-primary theme-text-primary"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value ? Number(e.target.value) : '')}
          >
            <option value="">All</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>{c.item}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1 theme-text-primary">Stage</label>
          <select
            className="border border-white  theme-border rounded-lg p-2  focus:outline-none focus:border-blue-500 focus:ring-0  theme-bg-primary theme-text-primary"
            value={stage}
            onChange={(e) => setStage(e.target.value)}
          >
            <option value="">All</option>
            {DEAL_STAGES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        <button
          onClick={onRefresh}
          className="px-4 py-2 rounded-lg theme-bg-secondary theme-border hover:opacity-80 transition-colors theme-text-primary custom-button"
        >
          Refresh
        </button>
      </div>

      {/* Search Bar */}
      <div className="mb-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 theme-text-tertiary w-5 h-5" />
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by name, customer, stage, project number..."
            className="w-full pl-10 pr-4 py-2 theme-border rounded-lg border border-white  theme-border rounded-lg p-2  focus:outline-none 
         focus:border-blue-500 
  focus:ring-0  theme-bg-primary theme-text-primary  border border-white theme-bg-primary theme-text-primary input-border1"
          />
        </div>
      </div>
    </>
  );
};

export default DealFilters;
